import * as React from "react";
import { Link, Route } from "react-router-dom";

interface ILiLink {
    to: string;
}
const LiLink: React.FC<ILiLink> = ({ children, to }) => {
    const fn = ({ match }: { match: string }) => {
        return (
            <li role="presentation" className={ match ? "active" : "" }>
                <Link to={ to }>{ children }</Link>
            </li>
        );
    };

    // eslint-disable-next-line react/no-children-prop
    return <Route path={ to } children={ fn } />;
};

interface NavProps {
    isGlobalMod: boolean;
}

class Nav extends React.Component<NavProps, {}> {
    get globalModLinks() {
        if (!this.props.isGlobalMod) {
            return null;
        }
        return (
            <>
            </>
        );
    }

    render() {
        return (
            <ul className="nav nav-tabs">
                <LiLink to="/toolbox/regioneditor">Regions</LiLink>
                <LiLink to="/toolbox/newusers">New users</LiLink>
                <LiLink to="/toolbox/eventeditor">Events</LiLink>
                <LiLink to="/toolbox/validate">Validate</LiLink>
                <LiLink to="/toolbox/useradmin">User admin</LiLink>
                <LiLink to="/toolbox/stateditor">Stat editor</LiLink>
                <LiLink to="/toolbox/sitrepadmin">Sitrep admin</LiLink>
                {this.globalModLinks}
            </ul>
        );
    }
}

export default Nav;
